var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMjmHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i06uu3xeaa",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    style: {
      fill: "#fff"
    },
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 19",
    d: "M4.284 13.505v-.517a74.838 74.838 0 0 1 0-1.55c-.057-1.962 1.4-2.948 2.351-3.6 1.016-.69 1.631-1.108 1.639-2.4v-.012a2.2 2.2 0 0 0-.484-1.665 2.939 2.939 0 0 0-2.09-.656h-.044a2.454 2.454 0 0 0-2.549 2.374A1.552 1.552 0 0 1 1.562 7H1.53A1.561 1.561 0 0 1 0 5.426 5.514 5.514 0 0 1 5.585.006L5.592 0h.1a5.859 5.859 0 0 1 4.331 1.6 5.158 5.158 0 0 1 1.358 3.9 5.648 5.648 0 0 1-2.992 4.909c-.923.632-1 .761-.995.993v.017c-.011.906-.005 1.219 0 1.538v.543a1.552 1.552 0 1 1-3.1 0z",
    transform: "translate(14.44 10.13)",
    style: {
      fill: "url(#i06uu3xeaa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 20",
    d: "M0 1.907a1.913 1.913 0 1 1 1.918 1.91A1.913 1.913 0 0 1 0 1.907z",
    transform: "translate(18.378 26.361)",
    style: {
      fill: "url(#i06uu3xeaa)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M13.758 28.771a15.01 15.01 0 1 1 10.614-4.4 15.01 15.01 0 0 1-10.614 4.4zm0-27.477a12.466 12.466 0 1 0 8.815 3.651 12.466 12.466 0 0 0-8.815-3.651z",
    transform: "translate(6.242 6.24)",
    style: {
      fill: "url(#i06uu3xeaa)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjmHelp);
export default __webpack_public_path__ + "static/media/MJM-Help.32505c354f5427500baaa4be70a1bf89.svg";
export { ForwardRef as ReactComponent };